import { render, staticRenderFns } from "./AddList.vue?vue&type=template&id=231f7fb2&scoped=true&"
import script from "./AddList.vue?vue&type=script&lang=js&"
export * from "./AddList.vue?vue&type=script&lang=js&"
import style0 from "./AddList.vue?vue&type=style&index=0&id=231f7fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f7fb2",
  null
  
)

export default component.exports